import {
	IconButton,
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	Modal,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import successImg from '../../assets/img/Successful.png';
import { Field, FieldArray, Formik } from 'formik';
import React from 'react';

const FieldInput = ({ field, ...props }) => {
	return <MimaInput {...field} {...props} />;
};

const FieldSelect = ({ field, ...props }) => {
	return <MimaDropdown {...field} {...props} />;
};

const BulkDeductFunds = ({
	closeModal,
	selectMethod,
	totalExtra,
	idsCount,
	onSubmit,
	validationSchema,
	addDeductionList,
	loading,
	method,
	deduction,
	addDeductions,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText
				variant="subtitle"
				width={38}
				mb={3}
				align="center"
				color="var(--color-primary)">
				{`Deduct Funds from ${idsCount} Employees`}
			</MimaText>
			{!method && !deduction && (
				<>
					<Formik
						initialValues={{
							payDeductions: [
								{
									type: '',
									amount: 0,
								},
							],
						}}
						validationSchema={validationSchema}
						onSubmit={onSubmit}>
						{({
							handleChange,
							handleBlur,
							handleSubmit,
							setFieldValue,
							values,
							errors,
							touched,
						}) => (
							<div>
								{values.payDeductions.length ? (
									<MimaText
										mb={2}
										align="center"
										color="var(--color-primary)"
										variant="bodyBold">
										Deductions
									</MimaText>
								) : (
									''
								)}
								<FieldArray name="payDeductions">
									{({ push, remove }) => (
										<React.Fragment>
											{values.payDeductions?.length
												? values?.payDeductions.map((item, i) => (
														<div key={i}>
															<Field
																as="select"
																component={FieldSelect}
																name={`payDeductions.${i}.type`}
																value={values.payDeductions[i].type}
																onChange={e => {
																	setFieldValue(
																		`payDeductions.${i}.type`,
																		e.value
																	);
																}}
																placeholder={
																	values.payDeductions[i].type ||
																	'Select Deduction type'
																}
																data={addDeductionList.map(item => ({
																	key: item,
																	value: item,
																}))}
																labelTitle="Deduction Type"
															/>
															<Field
																name={`payDeductions.${i}.amount`}
																type="number"
																component={FieldInput}
																labelTitle="Deduction Amount"
																min="0"
															/>

															{i >= 0 ? (
																<IconButton
																	variant="remove"
																	onClick={() => remove(i)}
																/>
															) : (
																''
															)}
															<div className={styles.employee__list_line}></div>
														</div>
													))
												: ''}
											<MimaButton
												title={`Add ${
													values.payDeductions.length > 0 ? 'Another' : ''
												} Deduction`}
												onClick={() =>
													push({
														amount: 0,
														type: '',
													})
												}
												variant="filter"
												mt={2}
											/>
											<MimaText
												mt={3}
												align="center"
												color="var(--color-error)"
												width={38}>
												{`${totalExtra(
													values.payDeductions
												)} would be deducted from the selected employees
													`}
											</MimaText>
										</React.Fragment>
									)}
								</FieldArray>
								<MimaButton
									disabled={loading}
									loading={loading}
									title="Save"
									type="submit"
									onClick={handleSubmit}
									mt={5}
								/>
							</div>
						)}
					</Formik>
				</>
			)}
			{method && (
				<>
					<MimaText
						width={38}
						mb={3}
						align="center"
						color="var(--color-primary)">
						45 employees Selected
					</MimaText>
					<MimaDropdown
						labelTitle="Deduction Type"
						placeholder="Deduction Type"
					/>
					<MimaInput labelTitle="Amount to Deduct" mt={2} />
					<MimaButton title="Continue" onClick={addDeductions} />
				</>
			)}

			{deduction && (
				<>
					<img
						src={successImg}
						alt="Upload success"
						className={styles.success}
					/>
					<MimaText
						variant="h3"
						width={38}
						align="center"
						color="var(--color-success)"
						mb={2}>
						Deductions removed <br />
						Successfully
					</MimaText>
					<MimaText width={38} align="center" color="var(--color-primary)">
						You successfully removed deductions to 50 employees
					</MimaText>
					<MimaButton title="Continue" onClick={closeModal} mt={3} />
				</>
			)}
		</Modal>
	);
};

export default BulkDeductFunds;
